const Menu = [
    {
        id: 1,
        image: './restaurant/images/allupakoida.jpg',
        title: 'Allu Pakoida',
        category: 'breakfast',
        description: 'Allu Pakoida:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 2,
        image: './restaurant/images/chola.jpg',
        title: 'Chola',
        category: 'lunch',
        description: 'Chola:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 3,
        image: './restaurant/images/corn.jpg',
        title: 'Corn',
        category: 'breakfast',
        description: 'Corn:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 4,
        image: './restaurant/images/maggi.jpg',
        title: 'Maggi',
        category: 'evening',
        description: 'Maggi:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 5,
        image: './restaurant/images/momo.jpg',
        title: 'Momo',
        category: 'lunch',
        description: 'Momo:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 6,
        image: './restaurant/images/paubhaji.jpg',
        title: 'PauBhaji',
        category: 'dinner',
        description: 'PauBhaji:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 7,
        image: './restaurant/images/pizza.jpg',
        title: 'Pizza',
        category: 'dinner',
        description: 'Pizza:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 8,
        image: './restaurant/images/puri.jpg',
        title: 'Puri',
        category: 'lunch',
        description: 'Puri:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
    {
        id: 9,
        image: './restaurant/images/sweet.jpg',
        title: 'Sweet',
        category: 'dinner',
        description: 'Sweet:- Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit repudiandae aut quam voluptatibus? Impedit minus atque fugit labore quasi consequatur reiciendis libero iste dignissimos fuga, perspiciatis corrupti vitae voluptatibus.'
    },
]
export default Menu